export default {
  'pages.markets.subtitle.apps': '發現並開通各類業務應用，豐富工作台能力。',
  'pages.markets.subtitle.skill':
    '探索豐富的 Skill 外掛與能力，提升 AI 智慧助手效能。',
  'pages.markets.subtitle.mcp':
    '發現並連接 MCP 服務與工具，拓展 AI 外部整合與調用能力。',
  'pages.markets.subtitle.digital_human':
    '探索官方數位人，快速複用預置指令與關聯 Skill。',
  'pages.markets.subtitle.plugin':
    '探索職閱客戶端插件，下載安裝包擴充客戶端能力。',
  'pages.markets.tab.apps': '應用市場',
  'pages.markets.tab.skill': 'Skill 市場',
  'pages.markets.tab.mcp': 'MCP 市場',
  'pages.markets.tab.digital_human': '數位人市場',
  'pages.markets.tab.plugin': '插件市場',
  'pages.markets.sources': '來源',
  'pages.markets.source.all': '全部',
  'pages.markets.source.official': '官方',
  'pages.markets.skillsShCountTooltip':
    'skills.sh 共收錄 {count} 個 Skill，可瀏覽榜單前 600 個',
  'pages.markets.search': '搜尋',
  'pages.markets.searchPlaceholder.apps': '搜尋應用名稱、描述或開發者...',
  'pages.markets.searchPlaceholder.skill':
    '搜尋 Skill 名稱、功能描述或發布方...',
  'pages.markets.searchPlaceholder.mcp':
    '搜尋 MCP 工具名稱、功能描述或發布方...',
  'pages.markets.searchPlaceholder.digital_human':
    '搜尋數位人名稱、能力描述或發布方...',
  'pages.markets.searchPlaceholder.plugin': '搜尋插件名稱、編碼或描述...',
  'pages.markets.sort.popular': '最受歡迎',
  'pages.markets.sort.latest': '最新上線',
  'pages.markets.sort.name': '名稱',
  'pages.markets.sort.all_time': '總榜',
  'pages.markets.sort.trending': '趨勢',
  'pages.markets.sort.hot': '熱門',
  'pages.markets.sortDisabledWithKeyword': '搜尋時排序不生效',
  'pages.markets.categories': '分類',
  'pages.markets.all': '全部',
  'pages.markets.loadedProgress': '已載入 {loaded} / 共 {total}',
  'pages.markets.loadedSimple': '已載入 {loaded}',
  'pages.markets.empty': '暫無市場內容',
  'pages.markets.noMatchingResults': '未找到符合條件的內容',
  'pages.markets.emptyDescription': '請嘗試調整搜尋關鍵字或切換分類。',
  'pages.markets.loadError': '市場數據載入失敗',
  'pages.markets.loadErrorDesc': '暫時無法獲取市場數據，請檢查網路後重試。',
  'pages.markets.failedSourcesWarning': '以下來源暫時無法載入：{sources}',
  'pages.markets.retry': '重試',
  'pages.markets.refresh': '重新整理',
  'pages.markets.clearFilters': '清空篩選',
  'pages.markets.loadingMore': '載入中...',
  'pages.markets.noMore': '沒有更多了',
  'pages.markets.loadMoreRetry': '載入失敗，點擊重試',
  'pages.markets.action.open': '開啟應用',
  'pages.markets.action.install': '安裝',
  'pages.markets.action.installed': '已開通',
  'pages.markets.action.freeActivate': '免費開通',
  'pages.markets.action.paidActivate': '購買開通',
  'pages.markets.action.contactRequired': '聯絡營運',
  'pages.markets.action.copyCommand': '複製安裝命令',
  'pages.markets.visitHomepage': '造訪官方網站',
  'pages.markets.viewOnSource': '在 {source} 查看',
  'pages.markets.codeRepository': '程式碼倉庫',
  'pages.markets.links': '相關連結',
  'pages.markets.installCommand': '安裝命令',
  'pages.markets.serviceEndpoint': '服務位址',
  'pages.markets.thirdPartyDisclaimer':
    '該內容來自第三方來源，珊瑚礁未做審核，請確認來源可信後再安裝。',
  'pages.markets.sourceLabel': '來源',
  'pages.markets.versionLabel': '版本',
  'pages.markets.installsLabel': '安裝量',
  'pages.markets.identifierLabel': '識別碼',
  'pages.markets.copy': '複製',
  'pages.markets.copySuccess': '安裝命令已複製到剪貼簿',
  'pages.markets.copyEndpointSuccess': '服務位址已複製到剪貼簿',
  'pages.markets.copyFailed': '複製失敗，請手動複製',
  'pages.markets.unknownPublisher': '未知發布方',
  'pages.markets.unknownDeveloper': '未知開發者',
  'pages.markets.noDescription': '暫無詳細介紹',
  'pages.markets.officialBadge': '官方',
  'pages.markets.featuredBadge': '推薦',
  'pages.markets.verifiedBadge': '來源方認證',
  'pages.markets.appBadge': '應用',
  'pages.markets.free': '免費',
  'pages.markets.paid': '付費',
  'pages.markets.pricePending': '待定價',
  'pages.markets.installs': '{count} 次安裝',
  'pages.markets.downloads': '{count} 次下載',
  'pages.markets.version': 'v{version}',
  'pages.markets.detailTitle': '應用詳情',
  'pages.markets.description': '介紹',
  'pages.markets.developer': '開發者',
  'pages.markets.certification': '認證狀態',
  'pages.markets.official': '官方認證',
  'pages.markets.unverified': '第三方',
  'pages.markets.category': '分類',
  'pages.markets.uncategorized': '未分類',
  'pages.markets.price': '價格',
  'pages.markets.previewImages': '功能預覽',
  'pages.markets.noPreview': '暫無預覽圖片',
  'pages.markets.previewAlt': '{name} 預覽圖 {index}',
  'pages.markets.confirmFreeTitle': '確認免費開通',
  'pages.markets.confirmFreeDescription':
    '確認開通應用「{name}」？開通後即可在工作台使用。',
  'pages.markets.confirmPaidTitle': '確認購買開通',
  'pages.markets.confirmPaidDescription':
    '確認購買應用「{name}」（{price}）？即將前往收銀台。',
  'pages.markets.confirm': '確認',
  'pages.markets.cancel': '取消',
  'pages.markets.activateSuccess': '應用開通成功',
  'pages.markets.alreadyActive': '該應用在當前租戶中已處於開通狀態',
  'pages.markets.activateError': '開通失敗，請稍後重試',
  'pages.markets.installSuccess': '安裝成功',
  'pages.markets.installError': '安裝失敗，請稍後重試',
  'pages.markets.skillPackageMissing': '該 Skill 暫未提供安裝包',
  'pages.markets.orderError': '訂單建立失敗，請稍後重試',
  'pages.markets.contactReason': '該應用需聯絡營運人員開通。',
  'pages.markets.unavailableUrl': '暫未配置可用的訪問地址',
  'pages.markets.close': '關閉',
  'pages.markets.action.download': '下載',
  'pages.markets.downloadError': '下載失敗，請稍後再試',
  'pages.markets.pluginEngine': '相容引擎',
  'pages.markets.pluginPermissions': '插件權限',
  'pages.markets.pluginNoPermissions': '無需額外權限',
  'pages.markets.pluginPermission.http': '網路請求',
  'pages.markets.pluginPermission.commands': '執行命令',
  'pages.markets.pluginPermission.storage': '本機儲存',
  'pages.markets.pluginPackageSize': '安裝包大小',
  'pages.markets.pluginUpdatedAt': '更新時間',
  'pages.markets.pluginReadme': '使用說明',
  'pages.markets.pluginVersions': '版本記錄',
  'pages.markets.pluginLatestTag': '目前版本',
  'pages.markets.pluginDownloadLatest': '下載最新版本',
};
